import { useRef, useCallback } from 'react';
import { values } from '@hydra/common/styles/breakpoints';

const DESKTOP_MARGIN = 120;
const MOBILE_MARGIN = 320;

const resizeObserver = typeof window !== 'undefined'
  // Explicitly typed because of clashing declarations
  // See https://github.com/que-etc/resize-observer-polyfill/issues/83
  ? new window.ResizeObserver((entries: ResizeObserverEntry[]) => {
      const margin = window.innerWidth > values.sm ? DESKTOP_MARGIN : MOBILE_MARGIN;
      const height = entries[0].contentRect.height + margin;
      // Used by the Extension
      return window.parent.postMessage(`com.woorank.height_${height}`, '*');
    })
  : null;

const useResizeIframe = () => {
  const cleanupRef = useRef<(() => void) | null>(null);
  return useCallback((elm) => {
    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }
    if (!resizeObserver || !elm) return;
    resizeObserver.observe(elm);
    cleanupRef.current = () => resizeObserver.unobserve(elm);
  }, []);
};

export default useResizeIframe;
